import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { QrCode, Download, Printer } from "lucide-react";
import { API } from "@/lib/api";

export default function QRDialog({ assetId, assetTag }) {
  const [open, setOpen] = useState(false);
  const [imgUrl, setImgUrl] = useState(null);

  const openDialog = async () => {
    setOpen(true);
    try {
      const res = await fetch(`${API}/assets/${assetId}/qr.png`, { credentials: "include" });
      const blob = await res.blob();
      setImgUrl(URL.createObjectURL(blob));
    } catch (e) { console.error(e); }
  };

  const download = () => {
    if (!imgUrl) return;
    const a = document.createElement("a");
    a.href = imgUrl; a.download = `qr-${assetTag}.png`; a.click();
  };

  const printQR = () => {
    if (!imgUrl) return;
    // Safer than document.write() — no HTML string injection, no XSS surface.
    const w = window.open("", "_blank");
    if (!w) return;
    // Build DOM programmatically so text/URL values are always treated as text, never HTML.
    w.document.title = `QR ${assetTag}`;
    const body = w.document.body;
    body.style.textAlign = "center";
    body.style.fontFamily = "sans-serif";
    body.style.padding = "40px";
    const img = w.document.createElement("img");
    img.src = imgUrl;              // blob: URL from URL.createObjectURL
    img.alt = "QR code";
    img.style.width = "320px";
    img.style.height = "320px";
    const caption = w.document.createElement("div");
    caption.style.marginTop = "16px";
    caption.style.fontWeight = "bold";
    caption.style.letterSpacing = "2px";
    caption.textContent = assetTag; // textContent → auto-escaped
    body.appendChild(img);
    body.appendChild(caption);
    setTimeout(() => { try { w.print(); } catch (err) { console.debug("print failed", err); } }, 400);
  };

  return (
    <>
      <button data-testid={`qr-btn-${assetId}`} onClick={openDialog} className="text-gray-500 hover:text-[#01ADEF]" title="QR code">
        <QrCode className="w-4 h-4" />
      </button>
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o && imgUrl) { URL.revokeObjectURL(imgUrl); setImgUrl(null); } }}>
        <DialogContent className="rounded-md max-w-sm">
          <DialogHeader><DialogTitle className="font-display">Asset QR — {assetTag}</DialogTitle></DialogHeader>
          <div className="flex flex-col items-center py-4">
            {imgUrl ? <img src={imgUrl} alt="QR" className="w-64 h-64 border border-gray-200" /> : <div className="w-64 h-64 border border-gray-200 flex items-center justify-center text-gray-400">Generating…</div>}
            <div className="flex gap-2 mt-4">
              <Button data-testid="qr-download" onClick={download} variant="outline" className="rounded-full"><Download className="w-4 h-4 mr-2" />Download</Button>
              <Button data-testid="qr-print" onClick={printQR} className="rounded-full bg-[#01ADEF] hover:bg-[#0198D6]"><Printer className="w-4 h-4 mr-2" />Print</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
